import * as constants from './constants';

export function addAccount(account) {
  return {
    type: constants.ADD_ACCOUNT,
    account,
  };
}

export function setTeamList(teams) {
  return {
    type: constants.SET_TEAM_LIST,
    teams,
  };
}

export function addAccountsList(accounts) {
  return {
    type: constants.ADD_ACCOUNTS_LIST,
    accounts,
  };
}

export function addWorkspacesList(workspaces) {
  return {
    type: constants.ADD_WORKSPACES_LIST,
    workspaces,
  };
}

export function addWorkspace(workspace) {
  return {
    type: constants.ADD_WORKSPACE,
    workspace,
  };
}

export function loadingWorkspace(loading) {
  return {
    type: constants.WORKSPACE_LOADING,
    loading,
  };
}

export function setTeamAccounts(teamId, accounts) {
  return {
    type: constants.SET_TEAM_ACCOUNTS,
    teamId,
    accounts,
  };
}

export function setWorkspaceCollaborators(workspaceId, collaborators) {
  return {
    type: constants.SET_WORKSPACE_COLLABORATORS,
    workspaceId,
    collaborators,
  };
}

export function setSelectedWorkspaceToStore(selectedWorkspace) {
  return {
    type: constants.SET_SELECTED_WORKSPACE,
    selectedWorkspace,
  };
}

export function setRequestAccessRequests(requests, statusFilter) {
  return {
    type: constants.SET_REQUEST_ACCESS_REQUESTS,
    requests,
    statusFilter,
  };
}

export function setRequestAccessLoaded(payload) {
  return {
    type: constants.SET_REQUEST_ACCESS_LOADED,
    payload,
  };
}
